module.exports = __webpack_public_path__ + "static/media/toolbox.6ca5e477.svg";